import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { Address } from '../../../core/data';
import { markAsTouched } from '../../utils';
import { requiredValidator } from '../../validators';

@Component({
  selector: 'app-address-modal',
  templateUrl: './address-modal.component.html',
})
export class AddressModalComponent {
  active = false;
  form = new FormGroup({
    id: new FormControl(),
    unit: new FormControl(null, Validators.maxLength(255)),
    street_number: new FormControl(null, [
      requiredValidator(),
      Validators.maxLength(255),
    ]),
    street: new FormControl(null, [
      requiredValidator(),
      Validators.maxLength(255),
    ]),
    suburb: new FormControl(null, [
      requiredValidator(),
      Validators.maxLength(255),
    ]),
    state: new FormControl(null, [
      requiredValidator(),
      Validators.maxLength(255),
    ]),
    postcode: new FormControl(null, [
      requiredValidator(),
      Validators.pattern(/^\d{4}$/),
    ]),
  });

  @Output() onChange = new EventEmitter<Address>();

  open(address: Address) {
    if (address) {
      this.form.patchValue(address);
    }

    this.active = true;
  }

  close() {
    this.form.reset();
    this.active = false;
  }

  submit() {
    if (this.form.valid) {
      this.onChange.emit(this.form.value);
    } else {
      markAsTouched(this.form);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/contacts/address-modal.component.ts